<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-2 mb-[40px]">
    {{ data?.id ? 'Submittals registry details' : 'Create submittals registry' }}
  </div>
  <div class="details flex-1">
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['section_no']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="section_no"
      label="Section No"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['sub_section_no']"
      [parentFormGroup]="form"
      class="w-full mb-[20px]"
      controlName="sub_section_no"
      label="Sub Section No"
    />
    <app-text-input
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['title']"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="title"
      label="title"
    />
    <app-text-area
      (checkForErrors)="checkForErrors($event)"
      [error]="errorMessages['description']"
      [parentFormGroup]="form"
      class="w-full mb-[10px]"
      controlName="description"
      label="description"
    />
  </div>
  <div class="action-section">
    <app-primary-button (handleClick)="save()" [isDisabled]="!isFormDirty">Save</app-primary-button>

  </div>
</div>
